<template>
    <el-card class="box-card">
        <el-tabs type="border-card" v-model="activeName" @tab-click="tabClickChange">
            <el-tab-pane name="first" label="原因模板">
                <div class="component-content">
                    <section class="content">
                        <el-form :inline="true" label-suffix=":">
                            <el-form-item>
                                <el-button size="small" type="primary" @click="addTemplateDialogShow">添加原因模板</el-button>
                            </el-form-item>
                        </el-form>

                        <el-table :data="templateData" border style="margin-top:20px;width: 100%">
                            <el-table-column prop="id" label='模板id'>
                            </el-table-column>
                            <el-table-column prop="createTime" label='创建时间'>
                            </el-table-column>
                            <el-table-column prop="reason" label='模板内容'>
                            </el-table-column>
                            <el-table-column label='操作'>
                                <template slot-scope="scope">
                                    <el-button type="text" @click="delReasonTemplate(scope.row.id)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </section>
                </div>

                <el-dialog title="添加原因模板" :visible.sync="addTemplateDialog" width="50%" lock-scroll center>
                    <el-form label-suffix=":" label-width="100px">
                        <el-form-item label="模板内容">
                            <el-input type="textarea" :maxlength="300" show-word-limit :autosize="{ minRows: 2}" v-model="reasonTemplateForm.reason" placeholder=''></el-input>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="addTemplateDialog = false">取消</el-button>
                        <el-button type="primary" @click="addReasonTemplate">确认</el-button>
                    </div>
                </el-dialog>
            </el-tab-pane>
            <el-tab-pane name="second" label="言论标签">
                <div class="component-content">
                    <section class="content">
                        <el-form :inline="true" label-suffix=":">
                            <el-form-item>
                                <el-button size="small" type="primary" @click="addOpinionTagDialogShow">添加言论标签</el-button>
                            </el-form-item>
                        </el-form>

                        <el-table :data="opinionTagData" border style="margin-top:20px;width: 100%">
                            <el-table-column prop="id" label='言论标签id'>
                            </el-table-column>
                            <el-table-column label='言论标签等级'>
                                <template slot-scope="scope">
                                    <span v-for="item in levelOptions" v-if="item.value === scope.row.level">{{item.label}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="createTime" label='创建时间'>
                            </el-table-column>
                            <el-table-column prop="reason" label='言论标签内容'>
                            </el-table-column>
                            <el-table-column label='操作'>
                                <template slot-scope="scope">
                                    <el-button type="text" @click="delOpinionTag(scope.row.id)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </section>
                </div>

                <el-dialog title="添加言论标签" :visible.sync="addOpinionTagDialog" width="50%" lock-scroll center>
                    <el-form label-suffix=":" label-width="100px">
                        <el-form-item label="标签等级">
                            <el-select v-model="opinionTagForm.level">
                                <el-option
                                    v-for="item in levelOptions"
                                    :key="item.value"
                                    :value="item.value"
                                    :label="item.label">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="言论标签内容">
                            <el-input type="textarea" :maxlength="20" show-word-limit :autosize="{ minRows: 2}" v-model="opinionTagForm.reason" placeholder=''></el-input>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="addOpinionTagDialog = false">取消</el-button>
                        <el-button type="primary" @click="addOpinionTag">确认</el-button>
                    </div>
                </el-dialog>
            </el-tab-pane>
            <el-tab-pane name="third" label="渠道设置">
                <div class="component-content">
                    <section class="content">
                        <el-form :inline="true" label-suffix=":">
                            <el-form-item>
                                <el-button size="small" type="primary" @click="addChannelDialogShow">添加渠道</el-button>
                            </el-form-item>
                        </el-form>

                        <el-table :data="channelData" border style="margin-top:20px;width: 100%">
                            <el-table-column prop="id" label='渠道id'>
                            </el-table-column>
                            <el-table-column prop="createTime" label='创建时间'>
                            </el-table-column>
                            <el-table-column prop="channel" label='渠道名称'>
                            </el-table-column>
                            <el-table-column prop="value" label='渠道值'>
                            </el-table-column>
                            <el-table-column label='操作'>
                                <template slot-scope="scope">
                                    <el-button type="text" @click="delChannel(scope.row.id)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </section>
                </div>

                <el-dialog title="添加渠道" :visible.sync="addChannelDialog" width="50%" lock-scroll center>
                    <el-form label-suffix=":" label-width="100px">
                        <el-form-item label="渠道名称">
                            <el-input  v-model="channelForm.channel"></el-input>
                        </el-form-item>
                        <el-form-item label="渠道值">
                            <el-input  v-model="channelForm.value"></el-input>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="addChannelDialog = false">取消</el-button>
                        <el-button type="primary" @click="addChannel">确认</el-button>
                    </div>
                </el-dialog>
            </el-tab-pane>
            <el-tab-pane name="fourth" label="媒体设置">
                <div class="component-content">
                    <section class="content">
                        <el-form :inline="true" label-suffix=":">
                            <el-form-item>
                                <el-button size="small" type="primary" @click="addMediaDialogShow">添加媒体值</el-button>
                            </el-form-item>
                        </el-form>

                        <el-table :data="mediaData" border style="margin-top:20px;width: 100%">
                            <el-table-column prop="id" label='媒体id'>
                            </el-table-column>
                            <el-table-column prop="createTime" label='创建时间'>
                            </el-table-column>
                            <el-table-column prop="media" label='媒体名称'>
                            </el-table-column>
                            <el-table-column prop="value" label='渠媒体值'>
                            </el-table-column>
                            <el-table-column label='操作'>
                                <template slot-scope="scope">
                                    <el-button type="text" @click="delMedia(scope.row.id)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </section>
                </div>

                <el-dialog title="添加媒体" :visible.sync="addMediaDialog" width="50%" lock-scroll center>
                    <el-form label-suffix=":" label-width="100px">
                        <el-form-item label="媒体名称">
                            <el-input  v-model="mediaForm.media"></el-input>
                        </el-form-item>
                        <el-form-item label="媒体值">
                            <el-input  v-model="mediaForm.value"></el-input>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="addMediaDialog = false">取消</el-button>
                        <el-button type="primary" @click="addMedia">确认</el-button>
                    </div>
                </el-dialog>
            </el-tab-pane>
        </el-tabs>
    </el-card>
</template>

<script>
    import configSettingApi from '../../service/config_setting_api'
    import {
        mapState
    } from 'vuex';

    export default {
        name: "parameter_manager",
        data () {
            return {
                activeName: 'first',

                // 原因模板
                templateData: [],
                addTemplateDialog: false,
                reasonTemplateForm: {
                    reason: ''
                },

                // 言论标签
                opinionTagData: [],
                addOpinionTagDialog: false,
                opinionTagForm: {
                    reason: '',
                    level: 1
                },

                levelOptions: [
                    {
                        value: 1,
                        label: '一级标签'
                    },
                    {
                        value: 2,
                        label: '二级标签'
                    }
                ],

                // 渠道
                channelData: [],
                addChannelDialog: false,
                channelForm: {
                    channel: '',
                    value: ''
                },

                // 媒体
                mediaData: [],
                addMediaDialog: false,
                mediaForm: {
                    media: '',
                    value: ''
                },
            }
        },
        computed: {
            ...mapState({
                token: state => state.user.userInfo.loginToken
            }),
        },
        mounted() {
            this.getReasonListAll();
        },
        methods: {
            tabClickChange(tab) {
                if (tab.name =='first') {
                    this.getReasonListAll();
                } else if (tab.name =='second') {
                    this.getOpinionTagListAll();
                } else if (tab.name =='third') {
                    this.getChannelsList();
                } else if (tab.name =='fourth') {
                    this.getMediasList();
                }
            },

            addTemplateDialogShow() {
                this.addTemplateDialog = true;
                this.reasonTemplateForm.reason = '';
            },

            // 添加原因模板
            addReasonTemplate() {
                configSettingApi.reasonSave({
                    token: this.token,
                    reasonTemplateForm: this.reasonTemplateForm
                }).then(res => {
                    this.addTemplateDialog = false;
                    this.$message({
                        type: 'success',
                        message: '添加成功!'
                    });
                    this.getReasonListAll();
                })
            },
            // 原因模板列表查询
            getReasonListAll() {
                configSettingApi.reasonList({
                    token: this.token
                }).then(res => {
                    this.templateData = res;
                })
            },
            // 删除原因模板
            delReasonTemplate(id) {
                configSettingApi.reasonDel({
                    token: this.token,
                    reasonTemplateForm: {
                        id: id
                    }
                }).then(res => {
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    })
                    this.getReasonListAll();
                })
            },

            addOpinionTagDialogShow() {
                this.addOpinionTagDialog = true;
                this.opinionTagForm.reason = '';
                this.opinionTagForm.level = 1;
            },

            // 添加言论标签
            addOpinionTag() {
                configSettingApi.opinionTagSave({
                    token: this.token,
                    opinionTagForm: this.opinionTagForm
                }).then(res => {
                    this.addOpinionTagDialog = false;
                    this.$message({
                        type: 'success',
                        message: '添加成功!'
                    });
                    this.getOpinionTagListAll();
                })
            },
            // 言论标签列表
            getOpinionTagListAll() {
                configSettingApi.opinionTagList({
                    token: this.token
                }).then(res => {
                    this.opinionTagData = res;
                })
            },
            // 删除言论标签
            delOpinionTag(id) {
                configSettingApi.opinionTagDel({
                    token: this.token,
                    opinionTagForm: {
                        id: id
                    }
                }).then(res => {
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    })
                    this.getOpinionTagListAll();
                })
            },

            addChannelDialogShow() {
                this.addChannelDialog = true;
                this.channelForm = {
                    channel: '',
                    value: ''
                }
            },

            // 增加渠道
            addChannel() {
                configSettingApi.channelSave({
                    token: this.token,
                    channelForm: this.channelForm
                }).then(res => {
                    this.addChannelDialog = false;
                    this.$message({
                        type: 'success',
                        message: '添加成功!'
                    });
                    this.getChannelsList();
                })
            },

            // 渠道列表
            getChannelsList() {
                configSettingApi.channelList({
                    token: this.token
                }).then(res => {
                    this.channelData = res;
                })
            },

            // 删除言论标签
            delChannel(id) {
                configSettingApi.channelDel({
                    token: this.token,
                    channelForm: {
                        id: id
                    }
                }).then(res => {
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    })
                    this.getChannelsList();
                })
            },

            addMediaDialogShow() {
                this.addMediaDialog = true;
                this.mediaForm = {
                    media: '',
                    value: ''
                }
            },

            // 增加媒体值
            addMedia() {
                configSettingApi.mediaSave({
                    token: this.token,
                    mediaForm: this.mediaForm
                }).then(res => {
                    this.addMediaDialog = false;
                    this.$message({
                        type: 'success',
                        message: '添加成功!'
                    });
                    this.getMediasList();
                })
            },

            // 媒体值列表
            getMediasList() {
                configSettingApi.mediaList({
                    token: this.token
                }).then(res => {
                    this.mediaData = res;
                })
            },

            // 删除媒体值
            delMedia(id) {
                configSettingApi.mediaDel({
                    token: this.token,
                    mediaForm: {
                        id: id
                    }
                }).then(res => {
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    })
                    this.getMediasList();
                })
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/maintenance/parameter_manager.vue